import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getRepairTypes,
  repairTypesListSuccessful,
  repairTypesAddSuccessful,
  isModelVisible,
} from "./repairTypesSlice";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";
// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";

function* getRepairTypesList({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/repairs/", params);
    yield put(repairTypesListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddRepairTypes({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/repairs/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Repair Types Added Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getRepairTypes({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Repair Types. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(repairTypesAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/repairs/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Repair Types Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getRepairTypes({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Repair Types. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(repairTypesAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteRepairTypes({ payload }) {
  var countryID = payload;
  try {
    const response = yield call(postDelete, "/masters/repairs/" + countryID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Repair Types has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getRepairTypes({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Repair Types has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchGetRepairTypes() {
  yield takeEvery("repairTypes/getRepairTypes", getRepairTypesList);
}
export function* watchRepairTypesAdd() {
  yield takeEvery("repairTypes/repairTypesAdd", AddRepairTypes);
}

export function* watchRepairTypesDelete() {
  yield takeEvery("repairTypes/repairTypesDelete", DeleteRepairTypes);
}

function* RepairTypesSaga() {
  yield all([
    fork(watchGetRepairTypes),
    fork(watchRepairTypesAdd),
    fork(watchRepairTypesDelete),
  ]);
}

export default RepairTypesSaga;
